import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";

export type SortOrder = "asc" | "desc";

interface Props<F extends string> {
  label: string;
  field: F;
  current: F;
  order: SortOrder;
  onChange: (field: F, order: SortOrder) => void;
  align?: "left" | "right";
  className?: string;
}

/** Clickable column header. Clicking the active column flips asc/desc;
 *  clicking an inactive column makes it active in ``desc`` (the natural
 *  default for "show me the biggest / newest first" admin tables). */
export function SortHeader<F extends string>({
  label, field, current, order, onChange, align = "left", className = "",
}: Props<F>) {
  const active = current === field;
  function click() {
    if (active) onChange(field, order === "asc" ? "desc" : "asc");
    else onChange(field, "desc");
  }
  const Icon = active ? (order === "asc" ? ArrowUp : ArrowDown) : ChevronsUpDown;
  return (
    <button
      type="button"
      onClick={click}
      className={`inline-flex items-center gap-1 select-none ${active ? "text-slate-800 font-semibold" : "text-slate-500 hover:text-slate-700"} ${className}`}
      aria-sort={active ? (order === "asc" ? "ascending" : "descending") : "none"}
      style={align === "right" ? { flexDirection: "row-reverse" } : undefined}
    >
      <span>{label}</span>
      <Icon className="h-3 w-3" />
    </button>
  );
}
